export default __webpack_public_path__ + "static/media/delievers21.bc59f34f.jpeg";